import React, { useRef } from "react";

interface DateSelectorProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  disabled?: boolean;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  selectedDate,
  onDateChange,
  disabled = false,
}) => {
  const dateInputRef = useRef<HTMLInputElement>(null);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(e.target.value);
    onDateChange(newDate);
  };

  // Format date as YYYY-MM-DD for the input value
  const formatDateForInput = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Open the date picker when clicked
  const handleClick = () => {
    if (dateInputRef.current && !disabled) {
      // Focus first to ensure browser will show the picker
      dateInputRef.current.focus();
      // Use a small timeout to ensure focus is complete before showing picker
      setTimeout(() => {
        if (dateInputRef.current) {
          // This works in most modern browsers
          dateInputRef.current.showPicker();
        }
      }, 50);
    }
  };

  // Reset date to today
  const resetToToday = () => {
    if (!disabled) {
      onDateChange(new Date());
    }
  };

  // Go to previous day
  const goToPreviousDay = () => {
    if (!disabled) {
      const previousDay = new Date(selectedDate);
      previousDay.setDate(previousDay.getDate() - 1);
      onDateChange(previousDay);
    }
  };

  // Go to next day
  const goToNextDay = () => {
    if (!disabled) {
      const nextDay = new Date(selectedDate);
      nextDay.setDate(nextDay.getDate() + 1);
      onDateChange(nextDay);
    }
  };

  return (
    <div className="date-selector">
      <label htmlFor="date-picker">Data: </label>
      <div className="input-wrapper" onClick={handleClick}>
        <input
          id="date-picker"
          type="date"
          ref={dateInputRef}
          value={formatDateForInput(selectedDate)}
          onChange={handleDateChange}
          disabled={disabled}
          autoComplete="off"
        />
      </div>
      <div className="date-navigation">
        <button
          className="today-link nav-button"
          onClick={goToPreviousDay}
          disabled={disabled}
          title="Ziua anterioară"
        >
          &lt;
        </button>
        <button
          className="today-link"
          onClick={resetToToday}
          disabled={disabled}
          title="Resetează la data de azi"
        >
          Astăzi
        </button>
        <button
          className="today-link nav-button"
          onClick={goToNextDay}
          disabled={disabled}
          title="Ziua următoare"
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default DateSelector;
